'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

import css from './entries.module.scss';
import { EntryGroup } from './entry-group';
import { ENTRY_STATUS_ORDER, type EntryInfo, type EntryStatus, groupByStatus, parseMetas } from './utils';

export function Entries() {
    const pathname = usePathname();
    const [allEntries, setAllEntries] = useState<EntryInfo[]>([]);
    const [openStatus, setOpenStatus] = useState<EntryStatus>('used');

    useEffect(() => {
        setAllEntries(parseMetas());
    }, [pathname]);

    const groups = groupByStatus(allEntries);

    const handleToggle = (status: EntryStatus) => {
        setOpenStatus(prev => (prev === status ? ('' as EntryStatus) : status));
    };

    return (
        <div className={css.column}>
            <div className={css.sidebar}>
                <p className={css.sectionHeading}>Contentful Entries ({allEntries.length})</p>
                {allEntries.length === 0 ? (
                    <p className={css.empty}>No entries found on this page.</p>
                ) : (
                    <div className={css.groups}>
                        {ENTRY_STATUS_ORDER.map(status => (
                            <EntryGroup
                                key={status}
                                status={status}
                                entries={groups[status]}
                                open={openStatus === status}
                                onToggle={() => handleToggle(status)}
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
